import { useLayoutEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { api } from 'src/app/services/api';
import { DemoPropsRo, UserLoginRo } from 'src/app/services/api.generated';
import { useAppDispatch } from 'src/app/reduxCustomHooks';
import { bootstrapAuthAction } from 'src/app/slices/authSlice';
import {
  exchangeEditorHandoff,
  handoffCodeFromHash,
  hashCarriesLegacyToken,
} from './exchangeEditorHandoff';

export type DemoAuthUser = UserLoginRo & {
  accountTier?: 'REGISTERED' | 'DEMO';
  demo?: DemoPropsRo;
};

const taskIdFromLocation = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const editTaskId = window.location.pathname.startsWith('/edit/')
    ? window.location.pathname.replace('/edit/', '')
    : null;

  return editTaskId || searchParams.get('taskId');
};

const clearHash = () => {
  window.history.replaceState(
    null,
    '',
    window.location.pathname + window.location.search
  );
};

export const useDemoAuthBootstrap = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isBootstrapping, setIsBootstrapping] = useState(() =>
    Boolean(handoffCodeFromHash(window.location.hash))
  );

  useLayoutEffect(() => {
    const code = handoffCodeFromHash(window.location.hash);
    if (!code) {
      if (hashCarriesLegacyToken(window.location.hash)) {
        clearHash();
      }
      setIsBootstrapping(false);
      return;
    }

    let cancelled = false;
    const taskId = taskIdFromLocation();
    setIsBootstrapping(true);
    exchangeEditorHandoff(code)
      .then((session) => {
        if (cancelled) return;
        dispatch(bootstrapAuthAction(session));
        if (process.env.NODE_ENV === 'development') {
          dispatch(api.util.resetApiState());
        }
        clearHash();
        navigate(taskId ? `/edit/${encodeURIComponent(taskId)}` : '/', {
          replace: true,
        });
      })
      .catch(() => {
        if (cancelled) return;
        clearHash();
      })
      .finally(() => {
        if (!cancelled) setIsBootstrapping(false);
      });

    return () => {
      cancelled = true;
    };
  }, [dispatch, navigate]);

  return isBootstrapping;
};
